import { format, parse } from "date-fns";

const DATETIME_FORMAT = "yyyy-MM-dd HH:mm:ss";

export const formatDate = (date: Date | null): string | null =>
    date ? format(date, DATETIME_FORMAT) : null;

export const parseDate = (date: string | null): Date | null =>
    date ? parse(date, DATETIME_FORMAT, new Date()) : null;
